const ensureClaimCoverConfig = [
  {
    url: '/ensure-claim/queryPosition',
    coverFields: [
      {
        field: 'process',
        keys: ['address']
      }
    ]
  },
  {
    url: '/ensure-claim/queryLastPosition',
    coverFields: ['address']
  },
  {
    url: '/ensure-claim/queryRelatedList', // 关联理赔单
    coverFields: ['reporterName', 'reporterPhone']
  },
  {
    url: '/ensure-claim/queryPinganFastClaimDetail', // 查询平安闪赔信息 to 页面暂无需展示的字段
    coverFields: [
      {
        field: 'data',
        keys: [
          'reporterName',
          'reporterTel',
          'insuredCertificateNo',
          'insuredPhoneNo',
          'driverCertificateNo',
          'driverPhoneNo',
          'drivingLicence',
          'accidentPlace'
        ]
      }
    ]
  },
  {
    url: '/ensure-claim/user/getUser', // 查询用户信息 to
    coverFields: ['userName', 'phone']
  },
  {
    url: '/ensure-claim/order/waybillInfo', // 运单信息
    coverFields: ['driverPhone', 'truckNumber']
  }
]
export default ensureClaimCoverConfig
